export enum RoleEnum {
  // has to match the IDs in the users_permission_role's db table
  Member = 1,
  Public = 2,
  Admin = 3,
  Basic = 4,
  READ = 5,
  READ_CUSTOMERS = 6,
}
